import { DomainItem } from "../interfaces/DomainItem"

export const getNavigationAddress = (tenantName: string, api: string, userDomains: DomainItem[], page: string): string => {
	if (userDomains &&
		userDomains.length > 0 &&
		userDomains.some(domain =>
			domain.DomainName?.toLowerCase() === tenantName?.toLowerCase() &&
			domain.APIName?.toLowerCase() === api?.toLowerCase())
	) { return `/${api?.toLowerCase()}/${tenantName?.toLowerCase()}/${page}` }
	else if (userDomains &&
		userDomains.length > 0
	) { return `/${userDomains[0].APIName.toLowerCase()}/${userDomains[0].DomainName.toLowerCase()}/${page}` }
	else { 
		console.error('NavigationHelper: getNavigationAddress: No userDomains found')
		return '/login' }
}

